module.exports = __webpack_public_path__ + "static/media/SantiagoP.07822ad4.jpg";